import { render, staticRenderFns } from "./NotesTitle.vue?vue&type=template&id=7748dcc4&scoped=true&"
import script from "./NotesTitle.vue?vue&type=script&lang=js&"
export * from "./NotesTitle.vue?vue&type=script&lang=js&"
import style0 from "./NotesTitle.vue?vue&type=style&index=0&id=7748dcc4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7748dcc4",
  null
  
)

export default component.exports